import { useState, useCallback, useMemo } from 'react';

export const useTopicSelection = (currentWorkspaceId, currentBasketId, allWorkspaceTopics, currentBasketTopics) => {
  const [selectedTopics, setSelectedTopics] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');

  // Use useMemo to calculate filtered topics
  const availableTopics = useMemo(() => {
    return allWorkspaceTopics.filter(topic => 
      !currentBasketTopics.some(basketTopic => basketTopic.id === topic.id)
    );
  }, [allWorkspaceTopics, currentBasketTopics]);

  const handleSearch = useCallback((term) => {
    setSearchTerm(term);
  }, []);

  const clearSearch = useCallback(() => {
    setSearchTerm('');
  }, []);

  const handleTopicToggle = useCallback((topicId) => {
    setSelectedTopics(prev => 
      prev.includes(topicId) 
        ? prev.filter(id => id !== topicId)
        : [...prev, topicId]
    );
  }, []);

  // Update the search filtering logic
  const searchedTopics = useMemo(() => {
    if (!searchTerm) return availableTopics;

    return availableTopics.filter(topic => {
      const searchRegex = new RegExp(searchTerm, 'i');
      return (
        searchRegex.test(topic.name) ||
        searchRegex.test(topic.tag?.name) ||
        searchRegex.test(topic.basket?.name) ||  // Add this line to search basket names
        topic.concepts?.some(concept => searchRegex.test(concept.text))
      );
    });
  }, [availableTopics, searchTerm]);

  return {
    availableTopics: searchedTopics,
    selectedTopics,
    searchTerm,
    handleSearch,
    handleTopicToggle,
    clearSearch,
  };
};
